module.exports = __webpack_public_path__ + "24e004ab/img/question-icon.06c20c5d.svg";